import { render, staticRenderFns } from "./OcbPoint.vue?vue&type=template&id=bad5ce9e&scoped=true"
import script from "./OcbPoint.vue?vue&type=script&lang=js"
export * from "./OcbPoint.vue?vue&type=script&lang=js"
import style0 from "./OcbPoint.vue?vue&type=style&index=0&id=bad5ce9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad5ce9e",
  null
  
)

export default component.exports